import pino from "pino";
import api from "@opentelemetry/api";
//#region src/index.ts
const isBrowser = typeof window !== "undefined";
const getEnv = (key) => {
	if (isBrowser) {
		if (typeof import.meta !== "undefined" && import.meta.env) return import.meta.env[key];
		if (typeof process !== "undefined" && process.env) return process.env[key];
		return;
	}
	return process.env[key];
};
const redactVariables = (message) => {
	if (!message) return message;
	return message.replace(/"variables[\\]?":{[^}]*}}/gi, "\"variables\":\"REDACTED\"");
};
const logger = pino({
	level: getEnv("LOG_LEVEL") ?? "info",
	formatters: {
		level: (label) => {
			return { level: label };
		},
		log: (log) => {
			const span = api.trace.getActiveSpan()?.spanContext();
			return {
				...log,
				dd: {
					trace_id: log.dd?.trace_id ?? span?.traceId,
					span_id: log.dd?.span_id ?? span?.spanId
				}
			};
		}
	},
	browser: isBrowser ? {
		asObject: true,
		write(o) {
			if ((getEnv("DEV") === "true" || getEnv("NODE_ENV") === "development") && "level" in o) console[o?.level === 50 ? "error" : "log"](o);
			else console.log(JSON.stringify(o));
		}
	} : void 0,
	hooks: { logMethod(inputArgs, method) {
		if (inputArgs && inputArgs.length) for (let i = 0; i < inputArgs.length; i++) {
			let arg = inputArgs[i];
			if (arg instanceof Error) try {
				arg.message = redactVariables(arg.message);
				arg.stack = redactVariables(arg.stack);
			} catch {}
			if (arg && typeof arg === "object" && "request" in arg) arg.request.variables = "Redacted";
			if (arg && typeof arg === "object" && "message" in arg && arg?.message) try {
				arg.message = redactVariables(arg?.message ?? "");
			} catch {}
			if (typeof arg === "string") arg = redactVariables(arg);
			inputArgs[i] = arg;
		}
		if (inputArgs[1] && inputArgs[1] instanceof Error) return method.apply(this, [inputArgs[1], inputArgs[0]]);
		return method.apply(this, inputArgs);
	} }
});
//#endregion
export { logger };

//# sourceMappingURL=index.mjs.map